import { contextFactory } from '@frontend/design-system';

export type QuickfillContainerContextProps = {
  closeModal: () => void;
  showTrayHeader?: boolean;
};

export const [QuickfillContainerContext, useQuickfillContainerContext] =
  contextFactory<QuickfillContainerContextProps>();
